import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import api, { naira } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function FestivalInvoiceCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("verifying");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const ref = params.get("reference") || params.get("trxref");
    if (!ref) {
      setState("failed");
      return;
    }
    api.get(`/festival-invoices/verify/${ref}`).then((r) => {
      if (r.data.status === "success") {
        setInfo(r.data.invoice);
        setState("success");
      } else {
        setState("failed");
      }
    }).catch(() => setState("failed"));
  }, [params]);

  return (
    <div className="min-h-screen bg-ink grain">
      <Navbar />
      <div className="pt-32 px-6 max-w-xl mx-auto" data-testid="festival-invoice-callback">
        <div className="rounded-2xl bg-surface border border-white/10 p-10 text-center">
          {state === "verifying" && (
            <>
              <Loader2 className="w-10 h-10 mx-auto text-terracotta animate-spin mb-4" />
              <h1 className="font-display text-2xl font-bold mb-2">Verifying your payment…</h1>
            </>
          )}
          {state === "success" && info && (
            <>
              <CheckCircle2 className="w-12 h-12 mx-auto text-emerald-400 mb-4" />
              <h1 className="font-display text-3xl font-black mb-2">Service fee paid · {naira(info.amount_naira)}</h1>
              <p className="text-foreground/70 mb-2">
                Festival: <span className="text-gold font-semibold">{info.festival_name}</span>
              </p>
              <p className="text-foreground/55 text-sm mb-6">
                The Cinevoya team will now process your submission. You'll get an email when it's submitted to the festival.
              </p>
              <Button onClick={() => navigate("/filmmaker")} className="bg-terracotta hover:bg-ember text-white">Back to dashboard</Button>
            </>
          )}
          {state === "failed" && (
            <>
              <XCircle className="w-12 h-12 mx-auto text-red-400 mb-4" />
              <h1 className="font-display text-3xl font-black mb-2">Payment failed</h1>
              <p className="text-foreground/70 mb-6">We couldn't verify your transaction. Please try the invoice again from the dashboard.</p>
              <Button onClick={() => navigate("/filmmaker")} className="bg-terracotta hover:bg-ember text-white">Back to dashboard</Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
